import { LightningOutScriptInjector } from '../types';

const LIGHTNING_OUT_SCRIPT_ID = 'lightning-out-script';

/**
 * Injects the Lightning.out script
 *
 * @remarks
 * Lightning.out must be dynamically injected in order to get access to the
 * $Lightning module. The module and url is specific to each organization
 */
const StandardInjector: LightningOutScriptInjector = {
  isInjected: (document: HTMLDocument) => {
    return (
      !!document.getElementById(LIGHTNING_OUT_SCRIPT_ID) &&
      !!window.$Lightning?.use
    );
  },

  inject: async (document: HTMLDocument, lightningUrl: string) => {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.id = LIGHTNING_OUT_SCRIPT_ID;
      script.type = 'text/javascript';
      script.async = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = (_event, _source, _line, _col, error) => {
        if (error) {
          reject(error);
        } else {
          reject(
            new Error('Unknown error when trying to inject lightning.out'),
          );
        }
      };

      script.src = `${lightningUrl}/lightning/lightning.out.js`;
      document.documentElement.appendChild(script);
    });
  },
};

export default StandardInjector;
